$(function () {
	const $overlay = $(".partials-search-popup");
	const $focusTarget = $overlay.find(".global-search-input, .search-input");

	function openSearch(){
		$("body").addClass("body-noscript-lock");
		$overlay.addClass("show");
		setTimeout(() => { $focusTarget.trigger("focus"); }, 10);
		$overlay.attr({"aria-hidden": "false", "role": "dialog", "aria-modal":"true"});
	}
	function closeSearch(){
		$("body").removeClass("body-noscript-lock");
		$overlay.removeClass("show");
		$overlay.attr("aria-hidden", "true");
	}

	$(".search-button").on("click", openSearch);
	$(".search-btn").on("click", openSearch);
	$(".close-search").on("click", closeSearch);
	$(document).on("keydown", function(e){
		if (e.key === "Escape" && $overlay.hasClass("show")) closeSearch();
	});

	// Bridge home → global
	$(".home-search-form").on("submit", function (e) {
		e.preventDefault();

		const q      = $("#home-search-input").val().trim();
		const $gForm = $("#global-search-form");
		const $gInput= $("#global-search-input");

		openSearch();

		$gInput.val(q)
			.trigger("input")  
			.trigger("change")
			.trigger("keyup");

		
		setTimeout(() => {
			const formEl = $gForm[0];
			if (!formEl) return;

			if (typeof formEl.requestSubmit === "function") {
				formEl.requestSubmit();      
			} else {
				const ev = new Event("submit", { bubbles: true, cancelable: true });
				formEl.dispatchEvent(ev);  
			}

			$gInput.trigger("focus");
		}, 30);
	});
});
